import { cn } from '@/lib/utils';
import { TransactionTypeEnum } from '@/enums';
import type { ITypeBadgeProps } from '@/interfaces';

export const TypeBadge = ({ type }: ITypeBadgeProps) => {
	const isIncome = type === TransactionTypeEnum.INCOME;
	return (
		<span className={cn('font-semibold text-sm', isIncome ? 'text-emerald-500' : 'text-red-500')}>
			{isIncome ? 'Revenu' : 'Dépense'}
		</span>
	);
};
